import { AUTH_URL, SERVER_PATH } from "../restEndpoint";
import { authHttpPost } from "../../utils/httpMethods";
import { httpPut } from "../../utils/httpMethods";
import axios from "axios";
import * as Sentry from "@sentry/react";
import { normalizeEmailInObject } from "../../utils/emailNormalizer";

const { logger } = Sentry;

export const SIGN_UP = async (data) => {
  // Normalize email before sending
  const normalizedData = normalizeEmailInObject({ ...data });
  return await authHttpPost({ url: `${AUTH_URL}/signup`, payload: normalizedData })
    .then((res) => {
      logger.info("Sign up successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Sign up error", { error: err.message });
      return err?.response;
    });
};
export const INDIVIDUAL_SIGN_UP = async (data) => {
  // Normalize email before sending
  const normalizedData = normalizeEmailInObject({ ...data });
  return await authHttpPost({
    url: `${AUTH_URL}/individual-signup`,
    payload: normalizedData,
  })
    .then((res) => {
      logger.info("Individual sign up successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Individual sign up error", { error: err.message });
      return err?.response;
    });
};

export const LOGIN = async (data) => {
  // Normalize email before sending
  const normalizedData = normalizeEmailInObject({ ...data });
  return await authHttpPost({ url: `${AUTH_URL}/login`, payload: normalizedData })
    .then((res) => {
      logger.info("Login successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Login error", { error: err.message });
      return err?.response;
    });
};

export const GOOGLE_AUTH = async (token) => {
  return await authHttpPost({
    url: `${AUTH_URL}/google-auth`,
    payload: { token },
  })
    .then((res) => {
      logger.info("Google auth successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Google auth error", { error: err.message });
      return err?.response;
    });
};

export const FORGOT_PASSWORD = async (data) => {
  // Normalize email before sending
  const normalizedData = normalizeEmailInObject({ ...data });
  return await authHttpPost({
    url: `${AUTH_URL}/forgot-password`,
    payload: normalizedData,
  })
    .then((res) => {
      logger.info("Forgot password request successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Forgot password error", { error: err.message });
      return err?.response;
    });
};

export const RESET_PASSWORD = async (data) => {
  // Normalize email before sending
  const normalizedData = normalizeEmailInObject({ ...data });
  return await authHttpPost({
    url: `${AUTH_URL}/reset-password`,
    payload: normalizedData,
  })
    .then((res) => {
      logger.info("Reset password successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Reset password error", { error: err.message });
      return err?.response;
    });
};

export const CHANGE_PASSWORD = async (data) => {
  return await httpPut({
    url: `${AUTH_URL}/change-password`,
    payload: data,
  })
    .then((res) => {
      logger.info("Change password successful");
      return res;
    })
    .catch((err) => {
      Sentry.captureException(err);
      logger.error("Change password error", { error: err.message });
      return err?.response;
    });
};

export const GET_CAPTCHA = async () => {
  try {
    const response = await axios.get(`${SERVER_PATH}/api/users/captcha`);
    logger.info("CAPTCHA fetched successfully");
    return response;
  } catch (err) {
    Sentry.captureException(err);
    logger.error("CAPTCHA fetch error", { error: err.message });
    throw err;
  }
};